import React, { useEffect, useMemo, useState } from 'react';
import FileLink from './FileLink';
import FileModal from '../video-overview/FileModal';
import { UserFile } from './FilesOverviewPage';
import { getFileById } from '../../services/api/fileService';
import { EVENT_KEYS, trackClick } from '../../services/api/trackingService';

interface FileDialogProps {
    file_id: string;
    buttonType?: string;
    disabled?: boolean;
    buttonText?: string;
    newTab?: boolean;
    trackingEvent?: EVENT_KEYS;
}

const FileDialog: React.FC<FileDialogProps> = ({
    file_id,
    buttonType = '',
    disabled = false,
    buttonText,
    newTab = false,
    trackingEvent,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentFile, setCurrentFile] = useState<UserFile | null>(null);

    const [file, setFile] = useState<UserFile | null>(null);

    useEffect(() => {
        const fetchFile = async () => {
            const file = await getFileById(file_id);
            console.log('file', file);
            setFile(file);
        };
        fetchFile();
    }, [file_id]);

    const handleFileClick = (clickedFile: UserFile) => {
        if (trackingEvent) {
            trackClick(trackingEvent, {
                attachmentName: clickedFile.filename,
            });
        }
        setCurrentFile(clickedFile);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setCurrentFile(null);
    };

    return (
        <>
            <FileLink
                file={file as UserFile}
                onClick={handleFileClick}
                buttonType={buttonType}
                disabled={disabled}
                buttonText={buttonText ?? file?.title ?? file?.filename}
                newTab={newTab}
            />

            {isModalOpen && currentFile && (
                <FileModal
                    file={{ ...currentFile, title: currentFile.filename }}
                    close={handleCloseModal}
                />
            )}
        </>
    );
};

export default FileDialog;
